export default "__VITE_ASSET__9bf7da4c__"